import {
  jb_e_service_icon_css_default
} from "./chunk.PDSLQYX5.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.4CJNI2ZH.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/icons/jb-e-service-icon/jb-e-service-icon.ts
var JbEServiceIcon = class extends Icon(i) {
  render() {
    return b`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="svg1"
        fill="none"
        viewBox="0 0 48 48"
      >
        <defs>
          <clipPath id="cover">
            <rect
              x="0"
              y="-10"
              width="100"
              height="27.2"
              fill="red"
            />
          </clipPath>
        </defs>
        <path
          id="body"
          d="M36.117 17.223H11.883q-1.18.001-2.031.845A2.76 2.76 0 0 0 9 20.108v20.007q0 1.18.852 2.033t2.033.852h24.23q1.18 0 2.033-.852T39 40.115V20.107q0-1.194-.852-2.039-.851-.844-2.03-.845m-24.232 2.27h24.23q.269 0 .442.173a.6.6 0 0 1 .173.441v20.008q0 .269-.173.442a.6.6 0 0 1-.442.173h-24.23a.6.6 0 0 1-.442-.173.6.6 0 0 1-.173-.442V20.107q0-.27.173-.441a.6.6 0 0 1 .442-.174"
          style="fill:currentColor"
        />
        <path
          id="dot"
          d="M23.992 26.723q-1.4 0-2.39 1.062-.99 1.061-.99 2.412 0 1.353 1 2.328.997.975 2.396.975t2.39-.977q.99-.975.99-2.35 0-1.326-1-2.388-.997-1.062-2.396-1.062"
          style="fill:currentColor"
        />
        <g clip-path="url(#cover)">
          <path
            id="shackle"
            d="M15.365 17.223h2.27v-4.588q0-2.652 1.861-4.508 1.862-1.857 4.512-1.857t4.504 1.857q1.853 1.857 1.853 4.508v26.588h2.27V12.635q0-3.595-2.516-6.115T24.006 4t-6.12 2.52q-2.52 2.52-2.52 6.115z"
            style="fill:currentColor"
          />
        </g>
      </svg>

      <slot></slot>
    `;
  }
};
JbEServiceIcon.styles = [reset_css_default, jb_e_service_icon_css_default];
JbEServiceIcon = __decorateClass([
  customElement("jb-e-service-icon")
], JbEServiceIcon);

export {
  JbEServiceIcon
};
